import script from "./MDataTableHeader.vue?vue&type=script&lang=js"
export * from "./MDataTableHeader.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__